import React, { useEffect, useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { setSuspensionWarningMessage } from 'utils/suspensions';
import * as moment from 'moment';
import {
  suspensionDateStatus,
  defaultStartDate,
  parameterDateFormat,
} from 'constants/suspensionConstants';
import SuspensionLayout from './SuspensionLayout';
import EditSuspensionForm from './EditSuspensionForm';
import AddSuspensionForm from './AddSuspensionForm';

export const AddSuspensionPage = (props) => {
  const {
    getSuspensionInfo,
    canSuspendIgnoreSuspensionRules,
    hasSuspensionRuleForAccount,
  } = props;
  const { adfitNo } = useParams();

  const handleSelectStartDate = useCallback(
    (startDate) =>
      getSuspensionInfo(
        adfitNo,
        canSuspendIgnoreSuspensionRules,
        startDate.format(parameterDateFormat),
        false
      ),
    [adfitNo, canSuspendIgnoreSuspensionRules, getSuspensionInfo]
  );
  //Load suspension rule
  useEffect(() => {
    handleSelectStartDate(defaultStartDate);
  }, [handleSelectStartDate]);

  return (
    <SuspensionLayout title="Add Suspension" {...props}>
      <AddSuspensionForm
        handleSelectStartDate={
          hasSuspensionRuleForAccount ? handleSelectStartDate : undefined
        }
      />
    </SuspensionLayout>
  );
};

export const EditSuspensionPage = (props) => {
  const {
    getSuspension,
    currentSuspension,
    getSuspensionInfo,
    canSuspendIgnoreSuspensionRules,
    hasSuspensionRuleForAccount,
  } = props;
  const { adfitNo, scheduleSuspenseId } = useParams();
  const history = useHistory();
  const { mandate } = currentSuspension;
  const handleSelectStartDate = useCallback(
    (startDate) =>
      getSuspensionInfo(
        adfitNo,
        canSuspendIgnoreSuspensionRules,
        startDate.format(parameterDateFormat),
        mandate
      ),
    [adfitNo, canSuspendIgnoreSuspensionRules, getSuspensionInfo, mandate]
  );

  useEffect(() => {
    getSuspension(adfitNo, scheduleSuspenseId)
      .then((res) => {
        if (res === '') {
          setSuspensionWarningMessage();
          history.push(`/Customers/${adfitNo}/Payments/Suspensions`);
        } else {
          //Today is greater than Suspension end date
          if (res.suspensionDateStatus === suspensionDateStatus.Expired) {
            setSuspensionWarningMessage('This suspension has expired.');
            history.push(`/Customers/${adfitNo}/Payments/Suspensions`);
          } else {
            //Load suspension rule
            handleSelectStartDate(moment(res.suspensionStartDate));
          }
        }
      })
      .catch((error) => {
        console.error(error);
        setSuspensionWarningMessage();
        history.push(`/Customers/${adfitNo}/Payments/Suspensions`);
      });
  }, [
    adfitNo,
    scheduleSuspenseId,
    getSuspension,
    history,
    handleSelectStartDate,
    mandate,
  ]);

  return (
    <SuspensionLayout title="Edit Suspension" {...props}>
      <EditSuspensionForm
        handleSelectStartDate={
          hasSuspensionRuleForAccount ? handleSelectStartDate : undefined
        }
        {...{ currentSuspension }}
      />
    </SuspensionLayout>
  );
};
